import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AddNewDocumentTypeForm from "../../components/pageManager/AddNewDocumentType";

const NewDocTypePage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AddNewDocumentTypeForm />
                </div>
            </div>
        </div>
    );
};

export default NewDocTypePage;
